<template>
  <figure
    class="relative flex items-center justify-center rounded-sm bg-white text-center shadow-md"
    :class="`logo-${size}`"
  >
    <picture
      v-if="options.image && !imgError"
      class="flex h-full w-full items-center justify-center"
    >
      <source :srcset="options.image" type="image/webp" />
      <img
        loading="lazy"
        :src="options.image"
        :alt="`${options.title} logo`"
        class="block h-full w-full object-contain py-2 md:py-0"
        :class="{ grayscale: options.grayscale }"
        @error="onImgError()"
      />
    </picture>
    <picture v-else class="flex h-full w-full items-center justify-center">
      <source :srcset="defaultImageUrl" type="image/webp" />
      <img
        loading="lazy"
        :src="defaultImageUrl"
        alt=""
        class="block h-full w-full object-contain py-2 md:py-0"
      />
    </picture>
    <figcaption class="sr-only">{{ options.title }} logo</figcaption>
    <div
      v-if="options.hoverClass"
      class="absolute h-full w-full mix-blend-multiply"
      :class="options.hoverClass"
    />
  </figure>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useHead } from '@unhead/vue'
import { usePageContext } from '../renderer/usePageContext'

const props = defineProps({
  options: {
    type: Object,
    default: () => {
      return {
        image: null,
        title: '',
        size: 140,
        grayscale: false,
        hoverClass: '',
      }
    },
  },
})

const defaultSize = 140
const defaultImageUrl =
  'https://jobsrepublic-too-images.imgix.net/company/_default/logo.png?trim=color&trimcolor=ff'
const imgError = ref(false)

const size = computed(() => {
  return props.options.size || defaultSize
})

function onImgError() {
  imgError.value = true
}

const pageContext = usePageContext()
useHead(() => {
  return {
    style: [
      {
        key: `logo-${size.value}`,
        nonce: pageContext.nonce,
        innerHTML: `
            figure.logo-${size.value} {
              --size: ${size.value}px;
              width: var(--size) !important;
              height: var(--size) !important;
            }
          `,
      },
    ],
  }
})
</script>
